<template>
    <div class="user">
        <!--内容-->
        <div class="product-content">
            <div class="table-wrap">
                <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
                    <el-table-column prop="name" label="姓名" align="center"></el-table-column>
                    <el-table-column prop="real_name" label="准考证" align="center"></el-table-column>
                    <el-table-column prop="create_time" label="生成时间" align="center"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="130" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="download(scope.row)">下载</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import SignApi from '@/api/sign.js';
    import { getCookie } from '@/utils/base.js';

    export default {
        data() {
            return {
                activeName: 'allfee',
                // 是否加载完成
                loading: true,
                // 列表数据
                tableData: [],
            };
        },
        created() {
            // 获取列表
            this.getTableList();
        },
        methods: {
            // 获取列表
            getTableList() {
                let that = this

                that.loading = true

                SignApi.getMyAdmissionList({
                    token: getCookie('token_supplier'),
                }, true)
                    .then(res => {
                        that.loading = false
                        that.tableData = res.data.list
                    })
                    .catch(error => {

                    });
            },

            // 下载准考证
            download(row){
                window.open(row.file_path,'_self');
            }


        }
    };
</script>

<style lang="scss" scoped>
    .el-form-item{
        margin-bottom: 25px;
    }
    .common-button-wrapper{
        bottom: 70px;
        background: transparent;
    }

    .draggable-list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .draggable-list .wrapper > span {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .draggable-list .item {
        position: relative;
        width: 110px;
        height: 110px;
        margin-top: 10px;
        margin-right: 10px;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #dddddd;
        cursor: pointer;
    }

    .draggable-list .delete-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 16px;
        height: 16px;
        background: red;
        line-height: 16px;
        font-size: 16px;
        color: #ffffff;
        display: none;
    }

    .draggable-list .item:hover .delete-btn {
        display: block;
    }

    .draggable-list .item img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-height: 100%;
        max-width: 100%;
    }

    .draggable-list .img-select {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #dddddd;
        font-size: 30px;
    }

    .draggable-list .img-select i {
        color: #409eff;
    }
</style>



// WEBPACK FOOTER //
// src/views/admission/index.vue